'use strict';

const Mn = require('backbone.marionette');
const CoverTemplate = require('balus/ui/template/body/process/title.hbs');

module.exports = Mn.View.extend({
    template: CoverTemplate,
    templateContext: function() {
        const parents = this.model.getAllParentsWithoutProject();

        return {
            parentActions: _.map(parents, p => {
                let j = p.toJSON();
                j.path = p.path();
                return j;
            })
        };
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/body/process/title.js